module.exports = "<div class=\"container\"  fxLayout=\"column\">\r\n  <div class=\"main-content\">\r\n    <p class=\"mat-display-4\">404</p>\r\n\r\n    <h1 class=\"mat-display-1\">Sorry, We couldn't find the page you are looking for. </h1>\r\n\r\n    <a mat-raised-button routerLink=\"/\" color=\"accent\">BACK TO HOME</a>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/page-not-found/page-not-found.component.html
// module id = ./src/app/shared/page-not-found/page-not-found.component.html
// module chunks = main